import { NgModule } from "@angular/core";
import { SharedModule } from "app/shared";
import { UploadComponent } from "./upload.component";
import { UploadRoutingModule } from "./upload.routing";
import { UploaderModule } from "./uploader/uploader.module";

@NgModule({
    declarations: [UploadComponent],
    imports: [UploadRoutingModule, SharedModule, UploaderModule],
})
export class UploadModule {}
